import {
  createAsyncThunk,
  createSelector,
  createSlice,
} from '@reduxjs/toolkit';
import { Agent } from '../../../ccf-directory/+state/ccf-directory.slice';

import { Message } from '../../../ccf-mocks/ccf-app-agent-messages/+state/ccf-conversations.slice';

export const CCF_CHAT_CONFERENCE_FEATURE_KEY = 'chatConference';

export interface ChatConference {
  isLoading: boolean;
  type: 'conference' | 'p2p';
  messages: Message[];
  page: number;
  userInConsult: Agent | null;
}

const intialState: ChatConference = {
  isLoading: false,
  type: 'p2p',
  messages: [],
  page: 0,
  userInConsult: null,
};

export const updateUserInConsult = createAsyncThunk(
  'chatConference/updateUserInConsult',
  async (user: Agent) => {
    const response = new Promise<Agent>((resolve, reject) =>
      setTimeout(() => resolve(user), 1000)
    );
    await response;
    return response;
  }
);

export const ccfChatConferenceSlice = createSlice({
  name: CCF_CHAT_CONFERENCE_FEATURE_KEY,
  initialState: intialState,
  reducers: {
    updateSelectedChat: (state, action) => {
      return {
        ...state,
        user: action.payload.user,
        messages: [],
        page: 0,
        endOfChat: false,
      };
    },
    updatePageCount: (state) => {
      return {
        ...state,
        page: state.page + 1,
      };
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateUserInConsult.pending, (state) => {
        return {
          ...state,
          isLoading: true,
          type: 'conference'
        };
      })
      .addCase(updateUserInConsult.fulfilled, (state, action) => {
        return {
          ...state,
          userInConsult: action.payload,
          isLoading: false,
        };
      });
  },
});

export const ccfChatConferenceReducer = ccfChatConferenceSlice.reducer;
export const ccfChatConferenceActions = ccfChatConferenceSlice.actions;

/**
 * Function to get chat conference
 * @param rootState - ChatConference
 * @returns It returns chat conference
 * @example - const chatConference = getChatConferenceState(rootState)
 */
const getChatConferenceState = (rootState: {
  chatConference: ChatConference;
}) => {
  return rootState[CCF_CHAT_CONFERENCE_FEATURE_KEY];
};

export const selectedConsultantForChat = createSelector(
  getChatConferenceState,
  (state) => state.userInConsult
);
export const getChatType = createSelector(
  getChatConferenceState,
  (state) => state.type
);
export const getChatLoadingState = createSelector(
  getChatConferenceState,
  (state) => state.isLoading
);

